/**
 * @generated SignedSource<<2367d6aefab615498f34796eda0a8ee6>>
 * @relayHash a8db36e1220f22ddd9b1a3ba8b1653a5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f74a761acc5e39201edc1b8c63569a3fba0635997e8887060d780c17d76ef914

import type { ConcreteRequest } from 'relay-runtime';
export type TemplateListQuery$variables = {
  isLicensed: boolean;
  sortingScheme?: string | null | undefined;
  spaceKey: string;
  teamType?: string | null | undefined;
};
export type TemplateListQuery$data = {
  readonly allTemplates: {
    readonly nodes: ReadonlyArray<{
      readonly author: string | null | undefined;
      readonly blueprintModuleCompleteKey: string | null | undefined;
      readonly categoryIds: ReadonlyArray<string | null | undefined>;
      readonly contentBlueprintId: string | null | undefined;
      readonly darkModeIconURL: string | null | undefined;
      readonly description: string | null | undefined;
      readonly hasGlobalBlueprintContent: boolean;
      readonly hasWizard: boolean | null | undefined;
      readonly iconURL: string | null | undefined;
      readonly isFavourite: boolean | null | undefined;
      readonly isNew: boolean | null | undefined;
      readonly isPromoted: boolean | null | undefined;
      readonly itemModuleCompleteKey: string | null | undefined;
      readonly keywords: ReadonlyArray<string | null | undefined> | null | undefined;
      readonly name: string | null | undefined;
      readonly recommendationRank: number | null | undefined;
      readonly styleClass: string | null | undefined;
      readonly templateId: string | null | undefined;
      readonly templateType: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly pageInfo: {
      readonly hasNextPage: boolean;
    } | null | undefined;
  } | null | undefined;
  readonly userPreferences?: {
    readonly favouriteTemplateEntityIds: ReadonlyArray<string | null | undefined>;
  } | null | undefined;
};
export type TemplateListQuery = {
  response: TemplateListQuery$data;
  variables: TemplateListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isLicensed"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortingScheme"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamType"
},
v4 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "sortingScheme",
        "variableName": "sortingScheme"
      },
      {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
      },
      {
        "kind": "Variable",
        "name": "teamType",
        "variableName": "teamType"
      }
    ],
    "concreteType": "PaginatedTemplateInfoList",
    "kind": "LinkedField",
    "name": "allTemplates",
    "plural": false,
    "selections": [
      {
        "concreteType": "TemplateInfo",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "templateId"
          },
          {
            "kind": "ScalarField",
            "name": "contentBlueprintId"
          },
          {
            "kind": "ScalarField",
            "name": "blueprintModuleCompleteKey"
          },
          {
            "kind": "ScalarField",
            "name": "itemModuleCompleteKey"
          },
          {
            "kind": "ScalarField",
            "name": "templateType"
          },
          {
            "kind": "ScalarField",
            "name": "name"
          },
          {
            "kind": "ScalarField",
            "name": "description"
          },
          {
            "kind": "ScalarField",
            "name": "iconURL"
          },
          {
            "kind": "ScalarField",
            "name": "darkModeIconURL"
          },
          {
            "kind": "ScalarField",
            "name": "styleClass"
          },
          {
            "kind": "ScalarField",
            "name": "hasWizard"
          },
          {
            "kind": "ScalarField",
            "name": "isNew"
          },
          {
            "kind": "ScalarField",
            "name": "isPromoted"
          },
          {
            "kind": "ScalarField",
            "name": "isFavourite"
          },
          {
            "kind": "ScalarField",
            "name": "hasGlobalBlueprintContent"
          },
          {
            "kind": "ScalarField",
            "name": "categoryIds"
          },
          {
            "kind": "ScalarField",
            "name": "keywords"
          },
          {
            "kind": "ScalarField",
            "name": "recommendationRank"
          },
          {
            "kind": "ScalarField",
            "name": "author"
          }
        ]
      },
      {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "hasNextPage"
          }
        ]
      }
    ]
  },
  {
    "condition": "isLicensed",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "concreteType": "UserPreferences",
        "kind": "LinkedField",
        "name": "userPreferences",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "favouriteTemplateEntityIds"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "TemplateListQuery",
    "selections": (v4/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "TemplateListQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "a8db36e1220f22ddd9b1a3ba8b1653a5",
    "id": "f74a761acc5e39201edc1b8c63569a3fba0635997e8887060d780c17d76ef914",
    "metadata": {},
    "name": "TemplateListQuery",
    "operationKind": "query",
    "text": "query TemplateListQuery($spaceKey:String!,$sortingScheme:String,$isLicensed:Boolean!,$teamType:String)@allowHigherTimeout{allTemplates(spaceKey:$spaceKey,sortingScheme:$sortingScheme,teamType:$teamType){nodes{templateId,contentBlueprintId,blueprintModuleCompleteKey,itemModuleCompleteKey,templateType,name,description,iconURL,darkModeIconURL,styleClass,hasWizard,isNew,isPromoted,isFavourite,hasGlobalBlueprintContent,categoryIds,keywords,recommendationRank,author},pageInfo{hasNextPage}},userPreferences@include(if:$isLicensed){favouriteTemplateEntityIds}}"
  }
};
})();

(node as any).hash = "e7c3b9cd189520f1e98192b780cc4adf";

export default node;
